import React, { useState } from 'react';
import { ChevronDownIcon, MessageCircleIcon } from 'lucide-react';
import Button from '../ui/Button';
import { trackContact } from '../tracking/metaPixel';
import { useLanguage } from '../../context/LanguageContext';
import { getWhatsAppLink } from '../../utils/whatsappLink';
const FAQ = () => {
  const {
    t,
    language
  } = useLanguage();
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const whatsappLink = getWhatsAppLink(t.faq.whatsappMsg);
  return <section className="py-16 px-4 bg-sand-50" data-id="element-161" data-mp="3d2zxg0po0qdy">
      <div className="container mx-auto max-w-3xl" data-id="element-162" data-mp="3d28epqh62n53">
        <div className="text-center mb-10" data-id="element-163" data-mp="3i1td9zsfctha">
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-primary mb-4" data-id="element-164" data-mp="3i0rz3mg43qvc">
            {t.faq.headline}
          </h2>
          <p className="text-gray-600" data-id="element-165" data-mp="9kgfbr0pb0wv">{t.faq.subheadline}</p>
        </div>

        <div className="space-y-4 mb-10" data-id="element-166" data-mp="eekmaa9yv8xy">
          {t.faq.items.map((faq, index) => <div key={index} className={`bg-white rounded-xl border transition-all duration-300 ${openIndex === index ? 'border-success shadow-md' : 'border-gray-200'}`} data-id="element-167" data-mp="20ri0qcvnvic6" data-mpi={index}>
              <button className="w-full flex justify-between items-center p-5 text-left focus:outline-none" onClick={() => toggleFaq(index)} data-id="element-168" data-mp="2ahukw3zkd9hs">
                <span className={`font-bold text-lg ${openIndex === index ? 'text-primary' : 'text-gray-700'}`} data-id="element-169" data-mp="2jfn0zad40l68">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-5 h-5 transition-transform duration-300 ${openIndex === index ? 'transform rotate-180 text-success' : 'text-gray-400'}`} data-id="element-170" data-mp="2tevvq5fsu3tn" />
              </button>
              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-48 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-171" data-mp="z37lggkiipfl">
                <div className="p-5 pt-0 text-gray-600 leading-relaxed border-t border-gray-100 mt-2" data-id="element-172" data-mp="1jsi63dresqsw">
                  {faq.answer}
                </div>
              </div>
            </div>)}
        </div>

        <div className="text-center bg-white p-8 rounded-2xl shadow-sm border border-sand-200" data-id="element-173" data-mp="1xq6uuwolki38">
          <h3 className="font-bold text-xl text-primary mb-2" data-id="element-174" data-mp="22p9nfhne4vub">
            {t.faq.ctaTitle}
          </h3>
          <p className="text-gray-600 mb-6" data-id="element-175" data-mp="26qmv7xa1n93v">{t.faq.ctaText}</p>
          <Button href="#lead-form" variant="success" className="bg-[#25D366] hover:bg-[#20bd5a]" onClick={() => trackContact({
          location: 'faq_section',
          language,
          action: 'scroll_to_form'
        })} data-id="element-176" data-mp="26p23eff4649p">
            <MessageCircleIcon className="w-5 h-5 mr-2" data-id="element-177" data-mp="2qecfljfni732" />
            {t.faq.ctaButton}
          </Button>
        </div>
      </div>
    </section>;
};
export default FAQ;